// apps/web/src/lib/validators/auth.ts

import { z } from "zod";
// FIX: Changed the import source for Role to use the shared types package
import { Role } from "@logistics-platform/types"; 

export const RegisterSchema = z.object({
  fullName: z.string().min(3, "Full name must be at least 3 characters."),
  email: z.string().email("Please enter a valid email address."),
  
  phoneOne: z.string().min(9, "Please enter a valid primary phone number."),
  phoneTwo: z.string().optional(),
  
  password: z.string().min(6, "Password must be at least 6 characters."),
  confirmPassword: z.string().min(6, "Please confirm your password."),
  role: z.nativeEnum(Role, { errorMap: () => ({ message: "Please select a role." }) }),
})
.refine(data => data.password === data.confirmPassword, {
    message: "Passwords do not match.",
    path: ["confirmPassword"],
});

export const LoginSchema = z.object({
  email: z.string().email("Please enter a valid email."),
  password: z.string().min(1, "Password is required."),
});

// Create TypeScript types from the schemas
export type TRegisterSchema = z.infer<typeof RegisterSchema>;
export type TLoginSchema = z.infer<typeof LoginSchema>;